export default [{
        name: 'login',
        path: '/login',
        meta: {
            logined: false,
            title: '登录'
        },

        component: resolve => require(['@/view/login/index.vue'], resolve)
    },
    {
        name: 'register',
        path: '/register',
        meta: {
            logined: false,
            title: '注册'
        },
        component: resolve => require(['@/view/register/index.vue'], resolve)
    },
    {
        name: 'forgetpassword',
        path: '/forgetpassword',
        meta: {
            logined: false,
            title: '找回密码'
        },
        component: resolve => require(['@/view/forgetpassword/index.vue'], resolve)
    },
    {
        name: 'forgetpasswordemail',
        path: '/forgetpasswordemail',
        meta: {
            logined: false,
            title: '找回密码'
        },
        component: resolve => require(['@/view/forgetpasswordemail/index.vue'], resolve)
    },
    {
        name: 'forgetpasswordemailsign',
        path: '/forgetpasswordemailsign',
        meta: {
            logined: true,
            title: '找回密码'
        },
        component: resolve => require(['@/view/forgetpasswordemailsign/index.vue'], resolve)
    },
    {
        name: 'forgetpasswordmobile',
        path: '/forgetpasswordmobile',
        meta: {
            logined: false,
            title: '找回密码'
        },
        component: resolve => require(['@/view/forgetpasswordmobile/index.vue'], resolve)
    },
    {
        name: 'entering',
        path: '/entering',
        meta: {
            title: '完善信息'
        },
        component: resolve => require(['@/view/entering/index.vue'], resolve)
    },
    {
        name: 'typeselect',
        path: '/typeselect',
        meta: {
            title: '类型选择'
        },
        component: resolve => require(['@/view/typeselect/index.vue'], resolve)
    },
    {
        name: 'examine',
        path: '/examine',
        meta: {
            title: '审核'
        },
        component: resolve => require(['@/view/examine/index.vue'], resolve),
        beforeEnter: (to, from, next) => {
            //去除此页面body中的样式
            document.querySelector('body').removeAttribute('style')
            next();
        },
    },
    {
        name: 'examinemedia',
        path: '/examinemedia',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examinemedia/index.vue'], resolve)
    },
    {
        name: 'examinepersonal',
        path: '/examinepersonal',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examinepersonal/index.vue'], resolve)
    },
    {
        name: 'examinegovernment',
        path: '/examinegovernment',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examinegovernment/index.vue'], resolve)
    },
    {
        name: 'examineschool',
        path: '/examineschool',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examineschool/index.vue'], resolve)
    },
    {
        name: 'examinecompany',
        path: '/examinecompany',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examinecompany/index.vue'], resolve)
    },
    {
        name: 'examineinstitution',
        path: '/examineinstitution',
        meta: {
            title: '资料'
        },
        component: resolve => require(['@/view/examineinstitution/index.vue'], resolve)
    },
    {
        name: 'emailsuccess',
        path: '/emailsuccess',
        meta: {
            title: '注册成功'
        },
        component: resolve => require(['@/view/emailsuccess/index.vue'], resolve)
    },
    {
        name: 'emailactive',
        path: '/emailactive',
        meta: {
            logined: true,
            title: '注册成功'
        },
        component: resolve => require(['@/view/emailactive/index.vue'], resolve)
    },
    {
        name: 'publish',
        path: '/publish',
        meta: {
            title: '发表'
        },
        redirect: '/publish/article',
        component: resolve => require(['@/view/publish/default/index.vue'], resolve),
        beforeEnter: (to, from, next) => {
          var userinfo = JSON.parse(localStorage.getItem('userinfo'));
          if (userinfo.firstSchool == "N" && (userinfo.fieldType == 'Propaganda' || userinfo.fieldType == 'StudentWorker')){
            next({path:'/typeselect'});
          }else{
            //保存来源router
            localStorage.setItem('topublishfromrouter', from.path);
            next();
          }
        },
        children: [{
                name: 'article',
                path: 'article',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishtext/index.vue'], resolve)
            },
            {
                name: 'video',
                path: 'video',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishvideo/index.vue'], resolve)
            },
            {
                name: 'image',
                path: 'image',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishimages/index.vue'], resolve)
            }
        ]
    },
    {
        name: 'contribute',
        path: '/contribute',
        meta: {
            title: '发表'
        },
        redirect: '/contribute/article',
        component: resolve => require(['@/view/contribute/default/index.vue'], resolve),
        beforeEnter: (to, from, next) => {
            //保存来源router
            localStorage.setItem('topublishfromrouter', from.path);
            next();
        },
        children: [{
                name: 'article',
                path: 'article',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/contribute/contributetext/index.vue'], resolve)
            },
            {
                name: 'video',
                path: 'video',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/contribute/contributevideo/index.vue'], resolve)
            },
            {
                name: 'image',
                path: 'image',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/contribute/contributeimages/index.vue'], resolve)
            }
        ]
    },
    {
        name: 'main',
        path: '/',
        meta: {
            title: ''
        },
        component: resolve => require(['@/view/index.vue'], resolve),
        children: [{
                name: 'home',
                path: '',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/home/index.vue'], resolve)
            },
            {
                name: 'ad',
                path: '/ad',
                meta: {
                    title: '广告'
                },
                component: resolve => require(['@/view/ad/index.vue'], resolve)
            },
            {
                name: 'manageContent',
                path: '/manage/content',
                meta: {
                    title: '内容管理'
                },
                component: resolve => require(['@/view/manage/content/index.vue'], resolve)
            },
            {
                name: 'manageAuthormedia',
                path: '/manage/authormedia',
                meta: {
                    title: '专辑管理'
                },
                component: resolve => require(['@/view/manage/authormedia/index.vue'], resolve)
            },
            {
                name: 'effectiveActivity',
                path: '/manage/effectiveactivity',
                meta: {
                    title: '可参与活动'
                },
                component: resolve => require(['@/view/manage/effectiveactivity/index.vue'], resolve)
            },
            {
                name: 'myActivity',
                path: '/manage/myactivity',
                meta: {
                    title: '我的活动'
                },
                component: resolve => require(['@/view/manage/myactivity/index.vue'], resolve)
            },
            {
                name: 'rank',
                path: '/manage/rank',
                meta: {
                    title: '热度榜调整'
                },
                component: resolve => require(['@/view/manage/rank/index.vue'], resolve)
            },
            {
                name: 'manageAnnouncement',
                path: '/manage/announcement',
                meta: {
                    title: '公告管理'
                },
                component: resolve => require(['@/view/manage/announcement/index.vue'], resolve)
            },
            {
                name: 'manageAnnouncementcut',
                path: '/manage/announcementcut',
                meta: {
                    title: '公告管理'
                },
                component: resolve => require(['@/view/manage/announcementCut/index.vue'], resolve)
            },
            {
                name: 'manageContentaudit',
                path: '/manage/contentaudit',
                meta: {
                    title: '内容审核管理'
                },
                component: resolve => require(['@/view/manage/contentaudit/index.vue'], resolve)
            },
            {
                name: 'manageContentauditys',
                path: '/manage/contentauditys',
                meta: {
                    title: '内容审核管理'
                },
                component: resolve => require(['@/view/manage/contentauditys/index.vue'], resolve)
            },
            {
                name: 'manageContentauditcut',
                path: '/manage/contentauditcut',
                meta: {
                    title: '内容审核管理'
                },
                component: resolve => require(['@/view/manage/contentauditCut/index.vue'], resolve)
            },
            {
                name: 'Sourcemedia',
                path: '/manage/media',
                meta: {
                    title: '专辑审核'
                },
                component: resolve => require(['@/view/manage/media/index.vue'], resolve)
            },
            {
                name: 'Sourceclassify',
                path: '/manage/classify',
                meta: {
                    title: '专辑分类管理'
                },
                component: resolve => require(['@/view/manage/classify/index.vue'], resolve)
            },
            {
                name: 'manageAuditrecord',
                path: '/manage/auditrecord',
                meta: {
                    title: '内容审核记录'
                },
                component: resolve => require(['@/view/manage/auditrecord/index.vue'], resolve)
            },
            {
                name: 'tagword',
                path: '/manage/tagword',
                meta: {
                    title: '标签管理'
                },
                component: resolve => require(['@/view/manage/tagword/index.vue'], resolve)
            },
            {
                name: 'tagwordarticle',
                path: '/manage/tagword/:id',
                meta: {
                    title: '标签管理'
                },
                component: resolve => require(['@/view/manage/tagword/article/index.vue'], resolve)
            },
            {
                name: 'manageWatermark',
                path: '/manage/watermark',
                meta: {
                    title: '水印管理'
                },
                component: resolve => require(['@/view/manage/watermark/index.vue'], resolve)
            },
            {
                name: 'manageConfiguration',
                path: '/manage/configuration',
                meta: {
                    title: '系统配置'
                },
                component: resolve => require(['@/view/manage/Configuration/index.vue'], resolve)
            },
            {
                name: 'manageComment',
                path: '/manage/comment',
                meta: {
                    title: '评论管理'
                },
                component: resolve => require(['@/view/manage/comment/index.vue'], resolve)
            },
            {
                name: 'manageContentdetail',
                path: '/manage/commentdetail',
                meta: {
                    title: '评论管理详情'
                },
                component: resolve => require(['@/view/manage/commentdetail/index.vue'], resolve)
            },
            {
                name: 'manageStudio',
                path: '/manage/studio',
                meta: {
                    title: '校园号管理'
                },
                component: resolve => require(['@/view/manage/studio/index.vue'], resolve)
            },
            {
                name: 'manageStudioSingle',
                path: '/manage/studio/:id',
                meta: {
                    title: '校园号管理编辑'
                },
                component: resolve => require(['@/view/manage/studio/single/index.vue'], resolve)
            },
            {
                name: 'manageLevel',
                path: '/manage/level',
                meta: {
                    title: '等级管理'
                },
                component: resolve => require(['@/view/manage/level/index.vue'], resolve)
            },
            {
                name: 'manageLevelSingle',
                path: '/manage/level/:id',
                meta: {
                    title: '等级管理编辑'
                },
                component: resolve => require(['@/view/manage/level/single/index.vue'], resolve)
            },
            {
                name: 'manageActivity',
                path: '/manage/activity',
                meta: {
                    title: '活动管理'
                },
                component: resolve => require(['@/view/manage/activity/index.vue'], resolve)
            },
            {
                name: 'manageActivitySingle',
                path: '/manage/activity/:id',
                meta: {
                    title: '活动管理编辑'
                },
                component: resolve => require(['@/view/manage/activity/single/index.vue'], resolve)
            },
            {
                name: 'manageContributionAudit',
                path: '/manage/contributionaudit',
                meta: {
                    title: '投稿审核'
                },
                component: resolve => require(['@/view/manage/contributionaudit/index.vue'], resolve)
            },
            {
                name: 'manageGov',
                path: '/manage/gov',
                meta: {
                    title: '政务号管理'
                },
                component: resolve => require(['@/view/manage/gov/index.vue'], resolve)
            },
            {
                name: 'manageGovSingle',
                path: '/manage/gov/:id',
                meta: {
                    title: '政务号管理编辑'
                },
                component: resolve => require(['@/view/manage/gov/single/index.vue'], resolve)
            },
            {
                name: 'manageGroup',
                path: '/manage/group',
                meta: {
                    title: '校园号分组'
                },
                component: resolve => require(['@/view/manage/group/index.vue'], resolve)
            },
            {
                name: 'manageGroupSingle',
                path: '/manage/group/:id',
                meta: {
                    title: '校园号分组编辑'
                },
                component: resolve => require(['@/view/manage/group/single/index.vue'], resolve)
            },
            {
                name: 'manageHonor',
                path: '/manage/honor',
                meta: {
                    title: '校园号荣誉榜配置'
                },
                component: resolve => require(['@/view/manage/honor/index.vue'], resolve)
            },
            {
                name: 'manageHonorSingle',
                path: '/manage/honor/:id',
                meta: {
                    title: '校园号荣誉榜配置'
                },
                component: resolve => require(['@/view/manage/honor/single/index.vue'], resolve)
            },
            {
                name: 'manageHonorStudio',
                path: '/manage/honor/studio/:id',
                meta: {
                    title: '校园号荣誉榜配置'
                },
                component: resolve => require(['@/view/manage/honor/studio/index.vue'], resolve)
            },
            {
                name: 'manageHonorStudio2',
                path: '/manage/honor/studio2/order',
                meta: {
                    title: '校园号荣誉榜配置'
                },
                component: resolve => require(['@/view/studiohonor/index.vue'], resolve)
            },
            // {
            //     name: 'StuffMaterial',
            //     path: '/manage/stuff',
            //     meta: {
            //         title: '材料收集'
            //     },
            //     component: resolve => require(['@/view/manage/stuff/index.vue'], resolve)
            // },
            // {
            //     name: 'StuffContent',
            //     path: '/manage/stuff/:id',
            //     meta: {
            //         title: '材料收集'
            //     },
            //     component: resolve => require(['@/view/manage/stuff/content/index.vue'], resolve)
            // },
            {
                name: 'SourceMaterial',
                path: '/manage/material',
                meta: {
                    title: '视频素材管理'
                },
                component: resolve => require(['@/view/manage/material/index.vue'], resolve)
            },
            {
                name: 'SourceMaterialEnter',
                path: '/manage/material/enter',
                meta: {
                    title: '素材管理保存'
                },
                component: resolve => require(['@/view/manage/material/enter/index.vue'], resolve)
            },
            {
                name: 'manageAd',
                path: '/manage/ad',
                meta: {
                    title: '广告管理'
                },
                component: resolve => require(['@/view/manage/ad/index.vue'], resolve)
            },
            {
                name: 'manageAccount',
                path: '/manage/account',
                meta: {
                    title: '账号管理'
                },
                component: resolve => require(['@/view/manage/account/index.vue'], resolve)
            },
            {
                name: 'manageAccountSingle',
                path: '/manage/account/:id',
                meta: {
                    title: '校账号管理编辑'
                },
                component: resolve => require(['@/view/manage/account/single/index.vue'], resolve)
            },
            {
                name: 'settingsAccount',
                path: 'settings/account',
                meta: {
                    title: '账号信息'
                },
                component: resolve => require(['@/view/settings/account/index.vue'], resolve)
            },
            {
                name: 'wechataddsuccess',
                path: 'wechatadd/success',
                meta: {
                    title: '微信绑定成功'
                },
                component: resolve => require(['@/view/channel/wechatadd/wxaddsuccess/index.vue'], resolve)
            },
            {
                name: 'channelMInput',
                path: 'channel/minput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/minput/wechatlist', query: { type: 'input' } },
                component: resolve => require(['@/view/channel/channelminput/index.vue'], resolve),
                children: [{
                        name: 'miwechatlist',
                        path: 'wechatlist',
                        meta: {
                            title: '渠道-微信内容源'
                        },
                        component: require('@/view/channel/wechatlist/index.vue')
                    },
                    {
                        name: 'miwebsitelist',
                        path: 'websitelist',
                        meta: {
                            title: '渠道-网站内容源'
                        },
                        component: require('@/view/channel/websitelist/index.vue')
                    }
                ]
            },
            {
                name: 'channelEInput',
                path: 'channel/einput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/einput/wechatadd', query: { type: 'input' } },
                component: resolve => require(['@/view/channel/channeleinput/index.vue'], resolve),
                children: [{
                        name: 'eiwechatadd',
                        path: 'wechatadd',
                        meta: {
                            title: '渠道-微信内容源'
                        },
                        component: require('@/view/channel/wechatadd/index.vue')
                    },
                    {
                        name: 'eiwebsiteadd',
                        path: 'websiteadd',
                        meta: {
                            title: '渠道-网站内容源'
                        },
                        component: require('@/view/channel/websiteadd/index.vue')
                    }
                ]
            },
            {
                name: 'channelMOutput',
                path: 'channel/moutput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/moutput/wechatlist', query: { type: 'output' } },
                component: resolve => require(['@/view/channel/channelmoutput/index.vue'], resolve),
                children: [{
                        name: 'momicrobloglist',
                        path: 'microbloglist',
                        meta: {
                            title: '渠道-微博'
                        },
                        component: require('@/view/channel/microbloglist/index.vue')
                    },
                    {
                        name: 'mowechatlist',
                        path: 'wechatlist',
                        meta: {
                            title: '渠道-微信'
                        },
                        component: require('@/view/channel/wechatlist/index.vue')
                    }
                ]
            },
            {
                name: 'channelEOutput',
                path: 'channel/eoutput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/eoutput/wechatadd', query: { type: 'output' } },
                component: resolve => require(['@/view/channel/channeleoutput/index.vue'], resolve),
                children: [{
                        name: 'eowechatadd',
                        path: 'wechatadd',
                        meta: {
                            title: '渠道-微信'
                        },
                        component: require('@/view/channel/wechatadd/index.vue')
                    },
                    {
                        name: 'eomicroblogadd',
                        path: 'microblogadd',
                        meta: {
                            title: '渠道-微博'
                        },
                        component: require('@/view/channel/microblogadd/index.vue')
                    }
                ]
            },
            {
                name: 'settingsBasic',
                path: 'settings/basic',
                meta: {
                    title: '基本信息'
                },
                component: resolve => require(['@/view/settings/basic/index.vue'], resolve)
            },
            {
              name: 'studioAccount',
              path: 'settings/studioaccount',
              meta: {
                  title: '账号管理'
              },
              component: resolve => require(['@/view/settings/studioaccount/index.vue'], resolve)
            },
            {
                name: 'SourceLive',
                path: '/manage/live',
                meta: {
                    title: '直播管理'
                },
                component: resolve => require(['@/view/manage/live/index.vue'], resolve)
            },
            {
                name: 'SourceLiveEnter',
                path: '/manage/live/enter',
                meta: {
                    title: '直播管理保存'
                },
                component: resolve => require(['@/view/manage/live/enter/index.vue'], resolve)
            },
            {
                name: 'SourceFusionaudit',
                path: '/manage/fusionaudit',
                meta: {
                    title: '校园号审核'
                },
                component: resolve => require(['@/view/manage/fusionaudit/index.vue'], resolve)
            },
            {
                name: 'draftcount',
                path: '/manage/draftcount',
                meta: {
                    title: '发稿数管理'
                },
                component: resolve => require(['@/view/manage/draftcount/index.vue'], resolve)
            },
            {
                name: 'manageindex',
                path: '/manage/index',
                meta: {
                    title: '校园号指数管理'
                },
                component: resolve => require(['@/view/manage/indexmanage/index.vue'], resolve)
            },
            {
                name: 'managefiledtype',
                path: '/manage/filedtype',
                meta: {
                    title: '所属领域管理'
                },
                component: resolve => require(['@/view/manage/fieldType/index.vue'], resolve)
            },
            {
                name: 'managefiledtypedetail',
                path: '/manage/filedtype/:codetype',
                meta: {
                    title: '所属领域管理'
                },
                component: resolve => require(['@/view/manage/fieldType/single/index.vue'], resolve)
            },
            {
                name: 'SourceDatabase',
                path: '/manage/database',
                meta: {
                    title: '学校库管理'
                },
                component: resolve => require(['@/view/manage/database/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsContent',
                path: 'datastatistics/content',
                redirect: 'datastatistics/content/summary',
                meta: {
                    title: '数据统计'
                },
                component: resolve => require(['@/view/datastatistics/content/index.vue'], resolve),
                children: [{
                        name: 'datasummary',
                        path: 'summary',
                        meta: {
                            title: '数据统计-概况'
                        },
                        component: resolve => require(['@/view/datastatistics/content/summary/index.vue'], resolve)
                    },
                    {
                        name: 'exponential',
                        path: 'exponential',
                        meta: {
                            title: '数据统计-校园号指数'
                        },
                        component: resolve => require(['@/view/datastatistics/content/exponential/index.vue'], resolve)
                    },
                    {
                        name: 'contentdata',
                        path: 'contentdata',
                        meta: {
                            title: '数据统计-内容数据'
                        },
                        component: resolve => require(['@/view/datastatistics/content/contentdata/index.vue'], resolve)
                    }
                ]
            },
            {
                name: 'ManageDataStatisticsContent',
                path: 'managedatastatistics/content',
                redirect: 'managedatastatistics/content/summary',
                meta: {
                    title: '数据统计'
                },
                component: resolve => require(['@/view/manage/statistics/content/index.vue'], resolve),
                children: [{
                        name: 'datasummary',
                        path: 'summary',
                        meta: {
                            title: '数据统计-概况'
                        },
                        component: resolve => require(['@/view/manage/statistics/content/summary/index.vue'], resolve)
                    },
                    {
                        name: 'exponential',
                        path: 'exponential',
                        meta: {
                            title: '数据统计-校园号数据'
                        },
                        component: resolve => require(['@/view/manage/statistics/content//exponential/index.vue'], resolve)
                    },
                    {
                        name: 'contentdata',
                        path: 'contentdata',
                        meta: {
                            title: '数据统计-内容数据'
                        },
                        component: resolve => require(['@/view/manage/statistics/content/contentdata/index.vue'], resolve)
                    }
                ]
            },

            {
                name: 'DataStatisticsContentArticliesDetail',
                path: '/datastatistics/content/articliesDetail',
                meta: {
                    title: '数据统计-内容分析-文章详情'
                },
                component: resolve => require(['@/view/datastatistics/content/articliesDetail/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsContentVideoDetail',
                path: '/datastatistics/content/videoDetail',
                meta: {
                    title: '数据统计-内容分析-视频详情'
                },
                component: resolve => require(['@/view/datastatistics/content/videoDetail/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsFans',
                path: 'datastatistics/fans',
                redirect: 'datastatistics/fans/summary',
                meta: {
                    title: '数据统计-粉丝分析'
                },
                component: resolve => require(['@/view/datastatistics/fans/index.vue'], resolve),
                children: [{
                        name: 'fansummary',
                        path: 'summary',
                        meta: {
                            title: '粉丝分析-概况'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/summary/index.vue'], resolve)
                    },
                    {
                        name: 'attribute',
                        path: 'attribute',
                        meta: {
                            title: '粉丝分析-粉丝属性'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/attribute/index.vue'], resolve)
                    },
                    {
                        name: 'search',
                        path: 'search',
                        meta: {
                            title: '粉丝分析-兴趣探索'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/search/index.vue'], resolve)
                    },
                    {
                        name: 'fanslist',
                        path: 'fanslist',
                        meta: {
                            title: '粉丝分析-粉丝列表'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/fanslist/index.vue'], resolve)
                    }
                ]
            },
            {
                name: 'DataStatisticsSchool',
                path: 'datastatistics/school',
                meta: {
                    title: '校园号数据统计'
                },
                component: resolve => require(['@/view/datastatistics/school/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsSort',
                path: 'datastatistics/sort',
                meta: {
                    title: '数据统计-校园号指数'
                },
                component: resolve => require(['@/view/datastatistics/sort/index.vue'], resolve)
            },
            {
                name: 'schoollist',
                path: 'datastatistics/schoollist',
                meta: {
                    title: '数据统计-高校号列表'
                  },
                component: resolve => require(['@/view/datastatistics/schoollist/index.vue'], resolve)
            },
             {
                name: 'personallist',
                path: 'datastatistics/personallist',
                meta: {
                    title: '数据统计-专栏号列表'
                  },
                component: resolve => require(['@/view/datastatistics/personallist/index.vue'], resolve)
             },
            {
                name: 'publishlist',
                path: 'datastatistics/publishlist',
                meta: {
                    title: '数据统计-内容发布列表'
                  },
                component: resolve => require(['@/view/datastatistics/publishlist/index.vue'], resolve)
            },

             {
                name: 'publishstatistics',
                path: 'datastatistics/publishstatistics',
                meta: {
                    title: '数据统计-内容发布统计'
                  },
                component: resolve => require(['@/view/datastatistics/publishstatistics/index.vue'], resolve)
             },
             {
                name: 'workload',
                path: 'datastatistics/workload',
                meta: {
                    title: '数据统计-工作量统计'
                  },
                component: resolve => require(['@/view/datastatistics/workload/index.vue'], resolve)
             },
             {
              name: 'specifcworkload',
              path: 'datastatistics/specifcworkload',
              meta: {
                  title: '数据统计-工作量统计'
              },
              component: resolve => require(['@/view/datastatistics/workload/specificworkload/index.vue'], resolve)
           },
            {
                name: 'letterstation/list',
                path: '/letterstation/list',
                meta: {
                    title: '私信-列表'
                },
                component: resolve => require(['@/view/letterstation/list/index.vue'], resolve)
            },
            {
                name: 'letterstation/talk',
                path: '/letterstation/talk',
                meta: {
                    title: '私信-对话'
                },
                component: resolve => require(['@/view/letterstation/talk/index.vue'], resolve)
            },
            {
                name: 'letterstation/rule',
                path: '/letterstation/rule',
                meta: {
                    title: '私信-规则'
                },
                component: resolve => require(['@/view/letterstation/rule/index.vue'], resolve)
            },
            {
                name: 'apply',
                path: '/log/apply',
                meta: {
                    title: '入驻申请操作记录'
                },
                component: resolve => require(['@/view/log/apply/index.vue'], resolve)
            },
            {
                name: 'score',
                path: '/log/score',
                meta: {
                    title: '校园号扣分记录'
                },
                component: resolve => require(['@/view/log/score/index.vue'], resolve)
            },
            {
                name: 'logmanage',
                path: '/log/manage',
                meta: {
                    title: '校园号管理操作记录'
                },
                component: resolve => require(['@/view/log/manage/index.vue'], resolve)
            },
            {
                name: 'loginfo',
                path: '/log/info',
                meta: {
                    title: '校园号管理操作记录'
                },
                component: resolve => require(['@/view/log/info/index.vue'], resolve)
            },
            {
                name: 'message',
                path: '/message',
                meta: {
                    title: '消息设置'
                },
                component: resolve => require(['@/view/message/index.vue'], resolve)
            },
        ]
    },
    {
        name: 'article',
        path: '/article/:id',
        meta: {
            title: '文章'
        },
        component: resolve => require(['@/view/article/index.vue'], resolve)
    },
    {
        name: 'auditmedia',
        path: '/manage/media/auditmedia/:status/:id',
        meta: {
            title: '专辑审核详情'
        },
        component: resolve => require(['@/view/manage/media/auditmedia/index.vue'], resolve)
    },
    {
        name: 'manageMediaPublish',
        path: '/manage/authormedia/mediapublish',
        meta: {
            title: '专辑发布'
        },
        component: resolve => require(['@/view/publish/publishmedia/index.vue'], resolve),
        beforeEnter: (to, from, next) => {
            //保存来源router
            localStorage.setItem('topublishfromrouter', from.path);
            next();
        },
    },{
        name: 'Addmedia',
        path: '/manage/authormedia/addmedia/:id',
        meta: {
            title: '添加文章'
        },
        component: resolve => require(['@/view/manage/authormedia/addmedia/index.vue'], resolve),
    },
    {
        name: 'notice',
        path: '/notice/:id',
        meta: {
            title: '公告'
        },
        component: resolve => require(['@/view/notice/index.vue'], resolve)
    },
    {
        name: 'share',
        path: '/share/:id',
        meta: {
            logined: false,
            title: '分享'
        },
        component: resolve => require(['@/view/share/index.vue'], resolve)
    },

    {
        name: 'DataStatisticsContentArticliesDetail',
        path: '/datastatistics/content/articliesDetail',
        meta: {
            title: '数据统计-内容分析-文章详情'
        },
        component: resolve => require(['@/view/datastatistics/content/articliesDetail/index.vue'], resolve)
    },
    {
        name: 'DataStatisticsContentVideoDetail',
        path: '/datastatistics/content/videoDetail',
        meta: {
            title: '数据统计-内容分析-视频详情'
        },
        component: resolve => require(['@/view/datastatistics/content/videoDetail/index.vue'], resolve)
    },
    {
        name: '500',
        path: '/500',
        meta: {
            title: '500'
        },
        component: resolve => require(['@/view/500/index.vue'], resolve)
    },
    {
        name: '404',
        path: '*',
        meta: {
            title: '404'
        },
        component: resolve => require(['@/view/404/index.vue'], resolve)
    },

    {
        name: 'scanlist',
        path: '/scan/list',
        meta: {
            logined: false,
            title: '文章列表'
        },
        component: resolve => require(['@/view/scan/index.vue'], resolve)
    },
    {
        name: 'scan',
        path: '/scan/:id',
        meta: {
            logined: false,
            title: '预览'
        },
        component: resolve => require(['@/view/scan/detail/index.vue'], resolve)
    },

]



// WEBPACK FOOTER //
// ./src/router/routers.js